import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react'
import Draggable from 'react-draggable'

import { AppStateContext } from '../AppStateContext'
import Panel from '../../../elem/panel/Panel'
import WellDetailPanelHeader from './WellDetailPanelHeader'
import DataContextProvider from './DataContext'
import NitrateChart from './NitrateChart'
import DetailTabs from './DetailTabs'
import WellDetails from './WellDetails'
import ScreenDetails from './ScreenDetailList'
import SampleDetails from './SampleDetailList'
import WellTypeHistory from './WellTypeHistoryList'
import TimeWindowDropdown from './TimeWindowDropdown'
import { detailPanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
import ExpandableDetailChart from './ExpandableDetailChart'
import DetailChart from './DetailChart'

const Detail = () => {
    const { detailState } = useContext(AppStateContext)
    const [isDetailMenuExpanded, setIsDetailMenuExpanded] = useState(false)

    const visible = detailState.well.visible

    return (
        <DataContextProvider>
            {/* we cannot define the expanded chart inside of the detailPanelWrapper because
             the css display: '....' of the <Draggable /> screws things up */}
            <ExpandableDetailChart visible={visible} />
            <Draggable
                bounds="parent"
                handle=".wellDetailPanelHeader"
                positionOffset={{ x: '.75rem', y: '.75rem' }}
                disabled={isDetailMenuExpanded}
                position={isDetailMenuExpanded ? { x: 0, y: 0 } : null}
            >
                <div
                    className={`column is-4-desktop is-half-tablet is-full-mobile detailPanelWrapper ${
                        !visible ? 'is-invisible' : ''
                    } ${isDetailMenuExpanded ? 'transform-none' : ''}`}
                    style={
                        !isDetailMenuExpanded
                            ? { left: '35%', top: '40px' }
                            : {}
                    }
                >
                    <Panel panelClassConfig={panelClassConfig()}>
                        <WellDetailPanelHeader
                            setIsDetailMenuExpanded={setIsDetailMenuExpanded}
                        />
                        <div className="wellDetailWrapper">
                            <DetailChart />
                            <DetailTabs />
                            <WellDetails />
                            <ScreenDetails />
                            <SampleDetails />
                            <WellTypeHistory />
                        </div>
                    </Panel>
                </div>
            </Draggable>
        </DataContextProvider>
    )
}

export default Detail
